import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { DayCampPageOptions } from "../Constants/RegistrationPageOptions";
import EventCardList from "./EventCardList";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "./CheckoutForm";
import DateHelpers from "../Helper/DateHelpers";
import InputValidation from "../Helper/InputValidation";
import DataAccessHelper from "../Helper/DataAccessHelper";
import '../Styles/DayCampRegistrationPaymentCashCheck.scss';

function DayCampRegistrationPaymentCashCheck({ amountDue, setAmountDue, paymentAmount, setPaymentAmount, ProcessRegistration, paymentType, setPaymentType}) {
   const [registrationFee, setRegistrationFee] = useState()
   const [campFee, setCampFee] = useState()

   function CalculateAmountDue() {

      let totalPrice = (Number(registrationFee) + Number(campFee))
      console.log("registrationFee", registrationFee)
      console.log("camp fee", campFee)
      console.log("total price", totalPrice)

      setAmountDue(totalPrice - paymentAmount)
   }

   useEffect(() => {
      if (!paymentAmount) {
         return
      }
      console.log("payment amount", paymentAmount)
   }, [paymentAmount]);

   useEffect(() => {
      console.log("AmountDue", amountDue)
      if (!amountDue && amountDue != 0) {
         return
      }
      console.log("AmountDue", amountDue)

      setPaymentType("Cash/Check")
   }, [amountDue]);

   useEffect(() => {
      if(!paymentType){
         return
      }
      ProcessRegistration()
   },[paymentType])

   return (
      <div className="dayCampRegistrationPaymentCashCheckContent">
         <div className="dayCampRegistrationPaymentCashCheckHeading">
            Cash and Check Payments
         </div>
         <div className="dayCampRegistrationPaymentCashCheckFields">
            <label>Enter Regstration Fee</label>
            <input
               type="number"
               required
               value={registrationFee}
               onChange={(e) => {
                  setRegistrationFee(e.target.value)
               }}
            />
            <label>Enter Camp Fee</label>
            <input
               type="number"
               required
               value={campFee}
               onChange={(e) => {
                  setCampFee(e.target.value)
               }}
            />
            <label>Enter Payment Amount</label>
            <input
               type="text"
               required
               value={paymentAmount}
               onChange={(e) => {
                  setPaymentAmount(e.target.value)
               }}
            />

            <div className="calculateAmountDueButtons">
               <button onClick={() => CalculateAmountDue()}>
                  Submit
               </button>
            </div>
         </div>
      </div>
   )
}
export default DayCampRegistrationPaymentCashCheck